import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  finishAssigningUsersToJobs,
  finishInsertingJob,
  finishSettingStatus,
  finishSharingJobsWithOrganizations,
  finishUpdatingJob,
} from './jobsSlice';

interface StatusesState {
  readonly isLoadingJobs: boolean;
  readonly isInsertingJob: boolean;
  readonly isUpdatingJob: boolean;
  readonly isLoadingPdfsForMerging: boolean;
  readonly multiMergePdfsGenerating: number;
}

const initialState: StatusesState = {
  isLoadingJobs: false,
  isInsertingJob: false,
  isUpdatingJob: false,
  isLoadingPdfsForMerging: false,
  multiMergePdfsGenerating: 0,
};

const statusesSlice = createSlice({
  name: 'statuses',
  initialState,
  reducers: {
    decrementMultiMergePdfsGenerating: (state) => {
      state.multiMergePdfsGenerating -= 1;
    },
    incrementMultiMergePdfsGenerating: (state) => {
      state.multiMergePdfsGenerating += 1;
    },
    setIsInsertingJob: (state, action: PayloadAction<boolean>) => {
      state.isInsertingJob = action.payload;
    },
    setIsLoadingJobs: (state, action: PayloadAction<boolean>) => {
      state.isLoadingJobs = action.payload;
    },
    setIsLoadingPdfs: (state, action: PayloadAction<boolean>) => {
      state.isLoadingPdfsForMerging = action.payload;
    },
    setIsUpdatingJob: (state, action: PayloadAction<boolean>) => {
      state.isUpdatingJob = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(finishAssigningUsersToJobs, (state) => {
      state.isUpdatingJob = false;
    });
    builder.addCase(finishInsertingJob, (state) => {
      state.isInsertingJob = false;
    });
    builder.addCase(finishSettingStatus, (state) => {
      state.isUpdatingJob = false;
    });
    builder.addCase(finishSharingJobsWithOrganizations, (state) => {
      state.isUpdatingJob = false;
    });
    builder.addCase(finishUpdatingJob, (state) => {
      state.isUpdatingJob = false;
    });
  },
});

export const {
  decrementMultiMergePdfsGenerating,
  incrementMultiMergePdfsGenerating,
  setIsInsertingJob,
  setIsLoadingJobs,
  setIsLoadingPdfs,
  setIsUpdatingJob,
} = statusesSlice.actions;
export const statuses = statusesSlice.reducer;
